<template>
  <div>
    <v-dialog v-model="show" max-width="500">
      <v-card>
        <v-card-title class="headline">{{ $t('components.dialog.resetPassword.enterYourEmail') }}</v-card-title>

        <v-card-text>
          <v-text-field v-model="model.email" :label="$t('components.dialog.resetPassword.emailAddress')"></v-text-field>

          <p class="text-error" v-if="showError">{{ $t('components.dialog.resetPassword.resetError') }}</p>
          <p class="text-success" v-if="showSuccess">
            {{ $t('components.dialog.resetPassword.sendResetMailSuccessMessage') }}
          </p>

          <a class="mt-5" @click="openSignupDialog()">{{ $t('components.dialog.resetPassword.missingAccount') }}</a>
        </v-card-text>

        <v-card-actions class="pr-4 pb-3">
          <v-spacer></v-spacer>

          <v-btn text :disabled="running" @click="cancel()">
            {{ $t('common.cancel') }}
          </v-btn>

          <v-btn
            color="primary"
            class="black--text"
            :disabled="!!!model.email || running"
            :loading="running"
            @click="requestResetPassword()"
          >
          {{ $t('components.dialog.resetPassword.resetPassword') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <signup-dialog-component :visible="showSignupDialog" @close="signupClosed()"></signup-dialog-component>
  </div>
</template>

<script>
import { UserService } from '../../services/user.service';
import SignupDialogComponent from './SignupDialogComponent.vue';
import SignupVendorDialogComponent from './SignupVendorDialogComponent.vue';

export default {
  components: {
    SignupDialogComponent,
    SignupVendorDialogComponent,
  },

  props: {
    visible: Boolean,
    vendor: {
      type: Boolean,
      default: false,
    },
  },

  model: {
    prop: 'visible',
    event: 'update',
  },

  data() {
    return {
      model: {},
      showSignupDialog: false,
      showVendorSignupDialog: false,
      showError: false,
      showSuccess: false,
      running: false,
    };
  },

  computed: {
    show: {
      get: function () {
        return this.visible;
      },
      set: function (value) {
        this.$emit('update', value);

        if (value === false) {
          this.$emit('close');
        }
      },
    },
  },

  methods: {
    requestResetPassword() {
      this.showError = false;
      this.running = true;

      new UserService()
        .requestResetPassword(this.model)
        .then(() => {
          this.showSuccess = true;
          this.clearFields();
        })
        .catch(() => {
          this.showError = true;
          this.running = false;
        });
    },

    cancel() {
      this.clearFields();
      this.show = false;
    },

    clearFields() {
      this.model.email = '';
      this.running = false;
    },

    openSignupDialog() {
      this.clearFields();
      this.show = false;
      if (this.vendor) {
        this.showVendorSignupDialog = true;
      } else {
        this.showSignupDialog = true;
      }
    },

    signupClosed() {
      this.showSignupDialog = false;
    },

    signupVendorClosed() {
      this.showVendorSignupDialog = false;
    },
  },
};
</script>
